import ApiError from '../../../components/Errors/ApiError';
import HeadingNav from '../../../components/Layouts/HeadingNav';
import { useLocation, Redirect, useParams } from 'react-router-dom';
import { useCertificationInfo } from '../myTeamQueries';
import getLang from '../../../utils/getLang';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HeaderTextLoadingSkeleton } from '../../../components/Layouts/HeadingNav';
import UIRouterTabs from 'ui-addon-react-router-dom/UIRouterTabs';
import UIRouterTab from 'ui-addon-react-router-dom/UIRouterTab';
import MyTeamCertificationProfileActiveTab from '../components/certificationProfile/CertificationProfileActiveTab';
import MyTeamCertificationProfileExpiredTab from '../components/certificationProfile/CertificationProfileExpiredTab';
import MyTeamCertificationProfileInProgressTab from '../components/certificationProfile/CertificationProfileInProgressTab';
import { ListingPage } from 'foundations-components/transitional/components/ListingPage';
import RoundedCertificationBadge from '../components/RoundedCertificationBadge';
import { CERTIFICATIONS_PROFILE_BASE } from '../constants/routes';
import UsageTracker from '../../../utils/UsageTracker';
import { PAGE_NAMES } from '../../../constants/Navigation';
import { useEffect } from 'react';
import { trackCertificationStatusChange } from '../utils/trackingUtils';
import TabLiner from '../components/common/TabLiner';
import { HasGate } from '../../accounts';
import Card from '../components/common/Card';
import { FiltersCard } from '../../filters/components/FiltersCard';
import { View } from 'foundations-components/components/View';
import { PageHeader } from '../../header/components/PageHeader';
import { Flex } from 'foundations-components/components/Flex';
import ACSkeletonBox from 'academy-common-lib/components/loading/ACSkeletonBox';
import { useTheme } from 'foundations-theming/utils';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const RedirectToCertificationProfileDefaultTab = () => {
  const location = useLocation();
  const {
    pathname
  } = location;
  return /*#__PURE__*/_jsx(Redirect, {
    to: Object.assign({}, location, {
      pathname: `${pathname}/active`
    })
  });
};
const MyTeamCertificationProfile = () => {
  var _certificationInfo$ce;
  const {
    certificationId,
    certificationStatus
  } = useParams();
  const {
    certificationInfo,
    certificationInfoError
  } = useCertificationInfo(Number(certificationId), getLang());
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: PAGE_NAMES.MY_TEAM_CERTIFICATION_PROFILE
    });
  }, []);
  useEffect(() => {
    trackCertificationStatusChange(certificationStatus);
  }, [certificationStatus]);
  const theme = useTheme();
  if (certificationInfoError) {
    return /*#__PURE__*/_jsx(ApiError, {
      error: {
        status: 500
      },
      markerDefault: "CERTIFICATION_INFO_API_ERROR"
    });
  }
  const certificationProfileUrlFragment = `${CERTIFICATIONS_PROFILE_BASE}/${certificationId}`;
  return /*#__PURE__*/_jsx(HasGate, {
    fallback: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(HeadingNav, {
        icon: (certificationInfo === null || certificationInfo === void 0 ? void 0 : certificationInfo.icon) && /*#__PURE__*/_jsx(RoundedCertificationBadge, {
          iconUrl: certificationInfo.icon,
          size: "1000"
        }),
        subtitleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.heading.headingSubTitles.MY_TEAM_CERTIFICATION_PROFILE"
        }),
        titleText: (certificationInfo === null || certificationInfo === void 0 ? void 0 : certificationInfo.certificationName) || /*#__PURE__*/_jsx(HeaderTextLoadingSkeleton, {
          height: "24px",
          width: "300px"
        })
      }), /*#__PURE__*/_jsx(ListingPage, {
        headerComponent: null,
        children: /*#__PURE__*/_jsxs(UIRouterTabs, {
          children: [/*#__PURE__*/_jsx(UIRouterTab, {
            active: certificationStatus === 'active',
            replace: true,
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.certificationStatus.active"
            }),
            to: `${certificationProfileUrlFragment}/active`,
            children: /*#__PURE__*/_jsx(TabLiner, {
              children: /*#__PURE__*/_jsx(MyTeamCertificationProfileActiveTab, {
                certificationName: certificationInfo === null || certificationInfo === void 0 ? void 0 : certificationInfo.certificationName
              })
            })
          }), /*#__PURE__*/_jsx(UIRouterTab, {
            active: certificationStatus === 'expired',
            replace: true,
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.certificationStatus.expired"
            }),
            to: `${certificationProfileUrlFragment}/expired`,
            children: /*#__PURE__*/_jsx(TabLiner, {
              children: /*#__PURE__*/_jsx(MyTeamCertificationProfileExpiredTab, {})
            })
          }), /*#__PURE__*/_jsx(UIRouterTab, {
            active: certificationStatus === 'in-progress',
            replace: true,
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.certificationStatus.inProgress"
            }),
            to: `${certificationProfileUrlFragment}/in-progress`,
            children: /*#__PURE__*/_jsx(TabLiner, {
              children: /*#__PURE__*/_jsx(MyTeamCertificationProfileInProgressTab, {})
            })
          })]
        })
      })]
    }),
    gate: "Academy:UnifiedAcademy:Navigation",
    children: /*#__PURE__*/_jsxs(View, {
      children: [/*#__PURE__*/_jsx(PageHeader, {
        subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.heading.headingSubTitles.MY_TEAM_CERTIFICATION_PROFILE"
        }),
        title: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "500",
          children: [(certificationInfo === null || certificationInfo === void 0 ? void 0 : certificationInfo.icon) && /*#__PURE__*/_jsx(RoundedCertificationBadge, {
            iconUrl: certificationInfo.icon,
            size: "1000"
          }), (_certificationInfo$ce = certificationInfo === null || certificationInfo === void 0 ? void 0 : certificationInfo.certificationName) !== null && _certificationInfo$ce !== void 0 ? _certificationInfo$ce : /*#__PURE__*/_jsx(ACSkeletonBox, {
            animated: true,
            backgroundcolor: theme.color['fill-surface-recessed-hover'],
            "data-test-id": "header-text-loading-skeleton",
            shimmercolor: theme.color['fill-surface-recessed'],
            style: {
              display: 'inline-block',
              height: '24px',
              width: '300px'
            }
          })]
        })
      }), /*#__PURE__*/_jsx(FiltersCard, {
        paddingBlock: "500",
        paddingInline: "600",
        children: /*#__PURE__*/_jsxs(ButtonGroup, {
          children: [/*#__PURE__*/_jsx(RouterButton, {
            active: certificationStatus === 'active',
            replace: true,
            to: `${certificationProfileUrlFragment}/active`,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.certificationStatus.active"
            })
          }), /*#__PURE__*/_jsx(RouterButton, {
            active: certificationStatus === 'expired',
            replace: true,
            to: `${certificationProfileUrlFragment}/expired`,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.certificationStatus.expired"
            })
          }), /*#__PURE__*/_jsx(RouterButton, {
            active: certificationStatus === 'in-progress',
            replace: true,
            to: `${certificationProfileUrlFragment}/in-progress`,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.myTeam.certificationStatus.inProgress"
            })
          })]
        })
      }), /*#__PURE__*/_jsxs(Card, {
        children: [certificationStatus === 'active' && /*#__PURE__*/_jsx(MyTeamCertificationProfileActiveTab, {
          certificationName: certificationInfo === null || certificationInfo === void 0 ? void 0 : certificationInfo.certificationName
        }), certificationStatus === 'expired' && /*#__PURE__*/_jsx(MyTeamCertificationProfileExpiredTab, {}), certificationStatus === 'in-progress' && /*#__PURE__*/_jsx(MyTeamCertificationProfileInProgressTab, {})]
      })]
    })
  });
};
export default MyTeamCertificationProfile;